<template>
  <div class="container pap-form">
    <div v-if="redirectFrom === 'logout'">Goodbye!</div>
    <!-- <div v-if="redirectFrom === 'reqauth'">
      You must be logged in to access that resource.
    </div> -->
    <AlertCard
      v-if="showMustBeLoggedInAlert"
      class="mb-4"
      type="error"
      header="Oops: To access that resource..."
      message="...you must be logged in."
    />

    <div class="card">
      <!-- <h5 class="card-header bg-primary text-white">
        <i class="fas fa-sign-in-alt mr-2" aria-hidden="true"></i>Login
      </h5> -->
      <FormTitle title="Login" iconclass="fas fa-sign-in-alt mr-2" />
      <div class="card-body">
        <b-form novalidate @submit.prevent="login">
          <b-form-group
            id="email-group"
            label="Email"
            label-for="email"
            label-class="label-bold"
            :invalid-feedback="form.email.errorMsg"
            :state="form.email.valid"
          >
            <b-form-input
              id="email"
              :maxlength="fieldMaxLength('email')"
              placeholder="Email"
              @input="fieldOnInput('email')"
              v-model="form.email.value"
              :state="form.email.valid"
              trim
            ></b-form-input>
          </b-form-group>

          <PasswordField
            id="password"
            label="Password"
            :state="form.password.valid"
            :errorMsg="form.password.errorMsg"
            @password-value-input="setPassword($event, 'password')"
          />

          <FormErrorAlert
            :showAlert="showFormActionError"
            :msg="formErrorMsg"
          />

          <button
            @click="setSubmitted"
            type="submit"
            class="btn btn-block btn-submit pap-form__btn"
          >
            Login
          </button>
        </b-form>

        <p class="card-text text-center py-3">
          Forgot your password?
          <router-link class="card-link" to="/reset-password"
            >Click here.</router-link
          >
        </p>
        <div class="form-footer">
          <div class="container w-80">
            <div class="hr-label-wrapper">
              <div class="text-center">
                <p class="card-text hr-label bg-white">New Here?</p>
              </div>
              <div class="hr bg-navbar"></div>
            </div>
            <router-link to="/signup" class="btn btn-secondary btn-block"
              >Free Sign Up</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertCard from '@/components/notifications/AlertCard';
import FormTitle from '@/components/form/FormTitle';
import PasswordField from '@/components/form/FormPasswordField';
import FormErrorAlert from '@/components/form/FormErrorAlert';

import { Login } from '@/models/Login';

import stateUtil from '@/helpers/stateUtil';

import { mapGetters } from 'vuex';

export default {
  name: 'UserLogin',
  components: {
    AlertCard,
    FormTitle,
    PasswordField,
    FormErrorAlert,
  },
  data: function () {
    return {
      // passwordField: {
      //   inputType: "password",
      // },

      redirectFrom: '',

      pageAccess: '',

      // Form data
      form: {
        email: {
          value: '',
          valid: null,
          errorMsg: '',
        },
        password: {
          value: '',
          valid: null,
          errorMsg: '',
        },
      },

      // Text of any overall form error, e.g. validation error, submission result error, etc.
      formErrorMsg: '',

      // Form validation: true: Every field has a valid value; false: At least one field has an invalid value
      formValid: false,

      // Form submission result: Result of form submission (when validated).
      // true: Result of submitted form action was an error; false: Initial state - no error (since form
      // not submitted yet); methods can "reset" this to false to simulate initial state any time after a
      // form submission.
      formError: false,

      // Flag: true: Form submit button was clicked; false: Reset to primitive state, i.e. form not submitted
      formSubmitted: false,

      logoutClicked: false,
      //count: 0, // temp? as a visual cue that the error message changed (valid form, but faulty login attempts)
    };
  },

  computed: {
    ...mapGetters('auth', ['authUser']),

    showFormActionError: function () {
      return (this.formSubmitted && !this.formValid) || this.formError;
    },
    showMustBeLoggedInAlert: function () {
      // return this.$store.state.pageAccess === 'protected' ? true : false;
      return this.pageAccess === 'protected' ? true : false;
    },
  },

  methods: {
    setSubmitted: function () {
      this.formSubmitted = true;
    },
    resetSubmitted: function () {
      this.formSubmitted = false;
    },

    setPassword: function (passwordValue, fieldName) {
      this.form[fieldName].value = passwordValue;
      this.fieldOnInput(fieldName);
    },

    fieldMaxLength: function (fieldName) {
      return Login.getPropTruncateLength(fieldName) || 50;
    },

    // For given field fieldName, on input to the field, i.e. when the value changes, reset the
    // form state to its primitive/original state in terms of form error alerts, form field error alerts, etc.
    fieldOnInput: function (fieldName) {
      this.resetSubmitted(); // Reset 'form submitted' flag to false, i.e. "starting over" as tho form was never submitted.
      this.formError = false;
      if (this.form[fieldName].valid === false) {
        this.form[fieldName].valid = null; // Set to null to not show validation state feedback on the field, i.e. NO red/green styles
        console.log('test method called on field', fieldName);
      }
    },

    // beforeRouteEnter(to, from, next) {
    //   this.redirectFrom = to.query.redirect;
    // },
    // beforeRouteEnter(to, from, next) {
    //   console.log('to:', to, 'from', from);
    //   to.query.redirect = 'test';
    //   if (to.query.redirect) {
    //     next((vm) => {
    //       console.log('BEFORE ROUTE vm', vm);
    //       vm.redirectFrom = to.query.redirect;
    //     });
    //   } else {
    //     next();
    //   }
    // },

    login: async function () {
      // Form validation --------------
      this.setSubmitted();
      var formData = {};
      Object.keys(this.form).forEach((fieldName) => {
        formData[fieldName] = this.form[fieldName].value;
      });

      // The regex that checks valid email form does NOT like ALL caps, e.g. NAME@gmail.com (but, e.g. Name@gmail.com is ok).
      // So, lowercase the email.
      formData.email = formData.email.toLowerCase();

      Login.set(formData); // Validation here so, test if validation passed next...
      this.formValid = Login.validationPassed();
      if (!this.formValid) {
        this.formErrorMsg =
          'Ooops! Please correct the errors shown in the form above, then click Login again.';
        Login.validationErrors().forEach((err) => {
          var propName = Login.getErrorProp(err);
          this.form[propName].valid = false; // Set to false to show validation state feedback of 'invalid', i.e. red styles
          this.form[propName].errorMsg = Login.getErrorMsg(err);
        });
        return;
      }

      // Successful form validation -- attempt login
      try {
        await this.$fapi.login(this.form.email.value, this.form.password.value);
        await stateUtil.initState(this.$store, this.$fapi);

        this.$router.push('/');

        // setTimeout(function () {
        //   this.$router.push('/');
        // }, 2000);
      } catch (err) {
        this.formError = true;
        this.formErrorMsg = err;
      }
    },
  },

  created() {
    this.redirectFrom = this.$store.state.loginRdq;

    this.pageAccess = this.$store.state.pageAccess;
    this.$store.dispatch('setPageAccess', '');

    // this.$store.dispatch('setLoginRdq', '');

    if (this.$store.getters['auth/authUser']) {
      // this.$router.push('/');
    }
    // BELOW: NOT NEEDED now due to new routing handling (the "right" way to do things - this was hack)
    // if (this.$store.getters.lastAction === 'logout') {
    //   this.logoutClicked = true;
    //   this.$store.dispatch('resetLastAction');
    // }
  },
};
</script>

<style>
</style>